import { MenuItem as MuiMenuItem, type MenuItemProps as MuiMenuItemProps } from '@mui/material';
import { useForkRef } from '@mui/material/utils';
import { type ElementType, type ForwardedRef, forwardRef } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

const ANCHOR_ELEMENT: ElementType = 'a';

type Props = WithoutStyleOverrides<Omit<MuiMenuItemProps, 'ref'>> & {
  href?: string;
  target?: string;
};

// A hoisted declaration, not an inline function: inside a closure TS would narrow ANCHOR_ELEMENT to 'a'
// and reject the li-typed handlers on an anchor.
function MenuItemWithRef(props: Props, ref: ForwardedRef<HTMLElement>) {
  const { href, target, ...menuItemProps } = props;
  const elementRef = useForkRef(ref);

  if (href === undefined) {
    return <MuiMenuItem {...menuItemProps} ref={elementRef} />;
  }

  return <MuiMenuItem {...menuItemProps} ref={elementRef} component={ANCHOR_ELEMENT} href={href} target={target} />;
}

// forwardRef, not a `ref` prop: the app still runs React 18, where function components never receive `ref`.
export const MenuItem = forwardRef(MenuItemWithRef);

export type { Props as MenuItemProps };
